// extracted by mini-css-extract-plugin
export default {"backLink":"BackLink_backLink__tO0rw","skeletonLoadingAnimation":"BackLink_skeletonLoadingAnimation__4B1F4"};